/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isObject, isStringNotEmpty, objectHasPropertyString, isValidGuid } from "utils/empty-exists";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
import { AddLinkButton } from "./add-link-button";

const ImageListLink = (props) => {
    
    const {
        link: guid,
        updateLink,
    } = props;
    
    const { token } = useAuth();
    const [loadingLink, setLoadingLink] = useState(false);
    const [linkGuid, setLinkGuid] = useState(false);
    const [link, setLink] = useState();

    const loadLink = async (link_guid) => {
        if (isStringNotEmpty(link_guid) && isValidGuid(link_guid)) {
            let _link;
            try {
                _link = await SimpliCityAdminSDK.link.findOne(token, link_guid);
            } catch (err) {
                _link = undefined;
            }
            return _link;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (isStringNotEmpty(guid)) {
                setLoadingLink(true);
                const _link = await loadLink(guid);
                setLink(_link);
                setLoadingLink(false);
            } else {
                setLink(undefined);
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid")) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    const handleUpdate = (_link) => {
        updateLink(_link);
    };
    const onChangeLink = async (_link) => {
        setLink(_link);
        handleUpdate(_link?.guid);
    };
    const onRemoveLink = async () => {
        setLink(undefined);
        handleUpdate("");
    };

    return (
        <Fragment>
            {!loadingLink &&
                <>
                    <LinkSelectorWrapper
                        link={link}
                        setLink={setLink}
                        linkGuid={linkGuid}
                        setLinkGuid={setLinkGuid}
                        onLinkChange={(link) => onChangeLink(link)}
                        onLinkRemove={() => onRemoveLink()}
                        disabled={false}
                        loadingLink={loadingLink}
                        setLoadingLink={setLoadingLink}
                        AddComponent={AddLinkButton}
                    />
                </>
            }
        </Fragment>
    );
};
ImageListLink.displayName = "ImageListLink";
export { ImageListLink };
